import { Button, Switch, TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import MessagePanel from "../../components/messagePanel";
import { organizacjeActions } from "../../store/actions/organizacje.actions";
import { IDRaksStore } from "../../store/store";
import {
  Produkt,
  Organizacja,
  OrganizacjaWidok,
} from "../../store/types/organizacje";
import { OrganizacjeEdycjaStyle } from "../../styles/OrganizacjeEdycjaStyle";
import AlertDialog from "../../components/alertDialog";

interface OrganizacjeEdycjaProps {
  error: string;
  onDodaj: Function;
  closeDrawer?: Function;
  onSaveAction?: Function;
  editId: string;
  onDaj: Function;
  onEdytuj: Function;
  wybrana: OrganizacjaWidok;
  onZmienWybrana: Function;
  beforeExit?: boolean;
  blockExit?: Function;
  dostepneProdukty: Produkt[];
}

const OrganizacjeEdycja = (props: OrganizacjeEdycjaProps) => {
  const {
    onDodaj,
    closeDrawer,
    error,
    onSaveAction,
    editId,
    onDaj,
    onEdytuj,
    wybrana,
    onZmienWybrana,
    beforeExit,
    blockExit,
    dostepneProdukty,
  } = props;
  const [nazwa, setNazwa] = useState("");
  const [produkty, setProdukty] = useState(dostepneProdukty);
  const [dirty, setDirty] = useState(false);
  const [potwierdzWyjscie, setPotwierdzWyjscie] = useState(false);

  useEffect(() => {
    if (editId) {
      onDaj(editId).then((dto: Organizacja) => {
        setNazwa(dto.Nazwa);
        setProdukty(dto.Produkty);
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (beforeExit) {
      if (dirty) setPotwierdzWyjscie(true);
      else if (closeDrawer) closeDrawer();
    }
    // eslint-disable-next-line
  }, [beforeExit]);

  const zapisz = () => {
    if (editId) {
      onEdytuj(editId, nazwa, produkty).then((res: boolean) => {
        if (res) {
          if (closeDrawer) closeDrawer();
          if (onSaveAction) onSaveAction();
          if (wybrana.Id === editId)
            onZmienWybrana({
              ...wybrana,
              Nazwa: nazwa,
              Produkty: produkty,
            } as OrganizacjaWidok);
        }
      });
    } else {
      onDodaj(nazwa, produkty).then((res: boolean) => {
        if (res) {
          if (closeDrawer) closeDrawer();
          if (onSaveAction) onSaveAction();
        }
      });
    }
  };

  const changeSwitch = (e: any) => {
    console.log(dostepneProdukty,e)
    if (e.target.name === "Brunet")
      if (e.target.checked) setProdukty([...produkty, Produkt.Brunet]);
      else setProdukty(produkty.filter((x) => x !== Produkt.Brunet));
    else if (e.target.name === "Faktury")
      if (e.target.checked) setProdukty([...produkty, Produkt.Zioom]);
      else setProdukty(produkty.filter((x) => x !== Produkt.Zioom));
    else if (e.target.name === "KSeF")
      if (e.target.checked) setProdukty([...produkty, Produkt.Ksef]);
      else setProdukty(produkty.filter((x) => x !== Produkt.Ksef));
  };

  return (
    <>
      <OrganizacjeEdycjaStyle>
        <header>
          <h5>{editId ? "EDYCJA ORGANIZACJI" : "NOWA ORGANIZACJA"}</h5>
          <Button
            name="btnZapisz"
            color="secondary"
            variant="contained"
            onClick={zapisz}
          >
            ZAPISZ
          </Button>
        </header>
        {error ? (
          <MessagePanel mode="error" title="Błąd!" message={error} />
        ) : (
          <div />
        )}
        <form onChange={(e) => setDirty(true)}>
          <section>
            <h6>NAZWA</h6>
            <TextField
              label="NAZWA"
              value={nazwa}
              onChange={(e) => setNazwa(e.target.value)}
            />
          </section>
          <section>
            <h6>PRODUKTY</h6>
            {dostepneProdukty.includes(Produkt.Brunet) && (
              <div className="switch">
                <span className="body1">FINANSE I KSIĘGOWOŚĆ (BRUNET)</span>
                <Switch
                  name="Brunet"
                  checked={produkty.includes(Produkt.Brunet)}
                  onChange={changeSwitch}
                />
              </div>
            )}
            {dostepneProdukty.includes(Produkt.Zioom) && (
              <div className="switch">
                <span className="body1">FAKTURY (Faktury.raks.pl)</span>
                <Switch
                  name="Faktury"
                  checked={produkty.includes(Produkt.Zioom)}
                  onChange={changeSwitch}
                />
              </div>
            )}
            {dostepneProdukty.includes(Produkt.Ksef) && (
              <div className="switch">
                <span className="body1">KSeF (KSeF)</span>
                <Switch
                  name="KSeF"
                  checked={produkty.includes(Produkt.Ksef)}
                  onChange={changeSwitch}
                />
              </div>
            )}
          </section>
        </form>
      </OrganizacjeEdycjaStyle>
      {potwierdzWyjscie && blockExit && closeDrawer && (
        <AlertDialog
          mode="YesNo"
          title="Potwierdzenie"
          content="Czy chcesz opuścić formularz bez zapisywania danych?"
          onAccept={() => {
            closeDrawer();
          }}
          onCancel={() => {
            setPotwierdzWyjscie(false);
            blockExit();
          }}
        ></AlertDialog>
      )}
    </>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.organizacje.editError,
    wybrana: store.organizacje.wybrana,
    dostepneProdukty: store.settings.dostepneProdukty,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onDodaj: (nazwa: string, produkty: Produkt[]) =>
      dispatch(organizacjeActions.dodaj(nazwa, produkty)),
    onDaj: (id: string) => dispatch(organizacjeActions.daj(id)),
    onEdytuj: (id: string, nazwa: string, produkty: Produkt[]) =>
      dispatch(organizacjeActions.edytuj(id, nazwa, produkty)),
    onZmienWybrana: (org: OrganizacjaWidok) =>
      dispatch(organizacjeActions.zmienWybrana(org)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizacjeEdycja);
